module.exports = __webpack_public_path__ + "static/media/trubridge-tecnology-bg.b77cd383.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/screens/trueBridge/trubridge-tecnology-bg.jpg
// module id = 164
// module chunks = 0